<div class="end-transport-pause-dialog">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'End Pause' | translate: ['tmc.visit.overview.end-transport-pause-dialog.title' ,
      translationService.language]}}
    </h2>
    <i class="horizontal-divider"></i>

    <div class="top-info">
      <app-transport-info-panel [carrier]="data.carrier" [identifier]="data.identifier" [driver]="data.name"
        [scope]="data.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">
      {{'Do you really want to end the pause?' | translate: ['tmc.visit.overview.end-transport-paus.confirm-text' ,
      translationService.language]}}
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>

    <i class="horizontal-divider"></i>
    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" mat-dialog-close>{{'no' | translate:
        ['shared.confirm-dialog.action.no', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button class="confirm-button" (click)="confirm()">{{'yes' | translate:
        ['tmc.visit.overview.end-transport-pause-dialog.button.end', translationService.language]}}</button>
    </sc-actionbar>
  </div>

</div>